// @flow
export const STATUS_CODE_200 = 200;
export const STATUS_CODE_400 = 400;
export const STATUS_CODE_401 = 401;
export const STATUS_CODE_404 = 404;
export const STATUS_CODE_409 = 409;
export const STATUS_CODE_500 = 500;
